import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@indipia/shared';
import type { VendorInfoLite } from '../api/orderApi';
import { vendorDirectoryQueryOptions } from './useMaterialOrders';

/**
 * 거래처 id → 전화 맵. 5단계 거래처 목록(useVendorDirectory)과 같은 쿼리 키를 공유해 `/schedule/vendors` 를 한 번만 호출한다.
 * 전화가 없는 거래처는 맵에 넣지 않는다. 조회 실패는 빈 맵이 아니라 오류 상태. [자재파트너]가 켜졌을 때만 enabled.
 */
export function useShipVendorPhones(enabled: boolean) {
  const compId = useAuthStore((s) => s.user?.compId);
  return useQuery<VendorInfoLite[], Error, Map<number, string>>({
    ...vendorDirectoryQueryOptions(compId),
    enabled,
    select: (rows) => {
      const map = new Map<number, string>();
      for (const r of rows) {
        if (typeof r.vendorPhone === 'string' && r.vendorPhone.trim() !== '') map.set(r.vendorId, r.vendorPhone);
      }
      return map;
    },
  });
}
